import { isEmpty, isNull, isObject, isUndefined } from 'lodash';

export { default as useDeepCompareEffect } from './hooks/useDeepCompareEffect';

export const isValidValue = (value: any) => {
  let isValid = true;
  if (typeof value === 'string' && value.trim().length === 0) {
    isValid = false;
  }
  if (isObject(value) && isEmpty(value)) {
    isValid = false;
  }
  if (isUndefined(value) || isNull(value)) {
    isValid = false;
  }
  return isValid;
};
